// App
import React from 'react';

// Constellation
import { IconChevronLeftCircle, IconChevronRightCircle, Text } from '@zillow/constellation';

// Misc / utils
import BackHomeLeft from '../images/icons/backHomeLeft.inline.svg';
import BackHomeRight from '../images/icons/backHomeRight.inline.svg';
import * as S from './styles';

// Types
type ButtonPropTypes = {
  showScrollButton: boolean;
  showHomeButton: boolean;
  scrollClickHandler: () => void;
  homeClickHandler: () => void;
};

export const LeftDesktopButton = ({
  showScrollButton,
  showHomeButton,
  scrollClickHandler,
  homeClickHandler,
}: ButtonPropTypes) => {
  return (
    <S.ButtonsContainer>
      <S.Buttons>
        <IconChevronLeftCircle
          fontColor={showScrollButton ? 'brand' : 'gray300'}
          size="md"
          onClick={showScrollButton ? scrollClickHandler : null}
          style={{
            cursor: `${showScrollButton ? 'pointer' : 'default'}`,
          }}
        />

        <S.HomeButton
          style={
            {
              visibility: `${showHomeButton ? 'visible' : 'hidden'}`,
            } as React.CSSProperties
          }
        >
          <div onClick={homeClickHandler}>
            <BackHomeLeft />
          </div>
          <Text as="div" fontType="legal">
            My home
          </Text>
        </S.HomeButton>
      </S.Buttons>
    </S.ButtonsContainer>
  );
};

export const RightDesktopButton = ({
  showScrollButton,
  showHomeButton,
  scrollClickHandler,
  homeClickHandler,
}: ButtonPropTypes) => {
  return (
    <S.ButtonsContainer>
      <S.Buttons>
        <IconChevronRightCircle
          fontColor={showScrollButton ? 'brand' : 'gray300'}
          size="md"
          onClick={showScrollButton ? scrollClickHandler : null}
          style={{
            cursor: `${showScrollButton ? 'pointer' : 'default'}`,
          }}
        />

        <S.HomeButton
          style={
            {
              visibility: `${showHomeButton ? 'visible' : 'hidden'}`,
            } as React.CSSProperties
          }
        >
          <div onClick={homeClickHandler}>
            <BackHomeRight />
          </div>
          <Text as="div" fontType="legal">
            My home
          </Text>
        </S.HomeButton>
      </S.Buttons>
    </S.ButtonsContainer>
  );
};

export const LeftMobileButton = ({
  showHomeButton,
  homeClickHandler,
}: Pick<ButtonPropTypes, 'showHomeButton' | 'homeClickHandler'>) => {
  return (
    <S.MobileHomeButtonLeft
      style={
        {
          visibility: `${showHomeButton ? 'visible' : 'hidden'}`,
        } as React.CSSProperties
      }
    >
      <div onClick={homeClickHandler}>
        <BackHomeLeft />
      </div>
      <Text as="div" fontType="legal">
        My home
      </Text>
    </S.MobileHomeButtonLeft>
  );
};

export const RightMobileButton = ({
  showHomeButton,
  homeClickHandler,
}: Pick<ButtonPropTypes, 'showHomeButton' | 'homeClickHandler'>) => {
  return (
    <S.MobileHomeButtonRight
      style={
        {
          visibility: `${showHomeButton ? 'visible' : 'hidden'}`,
        } as React.CSSProperties
      }
    >
      <div onClick={homeClickHandler}>
        <BackHomeRight />
      </div>
      <Text as="div" fontType="legal">
        My home
      </Text>
    </S.MobileHomeButtonRight>
  );
};
